import { useEffect } from "react";

import { useStore } from "../../../store";

export default function Loader({ color }: { color?: string }) {
	const brandColor = useStore((state) => state.config?.theming?.brandColor);

	useEffect(() => {
		const loader = document.querySelector(".loader");
		if (loader instanceof HTMLElement) {
			loader.style.borderBottomColor = color ?? brandColor ?? "black";
			loader.style.borderLeftColor = color ?? brandColor ?? "black";
		}
	}, [color, brandColor]);

	return <div className="loader w-16 h-16"></div>;
}
